// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"101":"profit","422":"loss"}[chunkId] + ".bundle.js";
};